import React, { Component } from "react";
import { Box, Divider, Hidden, Drawer, Tabs, Tab } from "@material-ui/core";
import { Person, Group } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import { FirebaseContext } from "../../FirebaseInit";
import myStyle from "./Style";
import PrivateTab from "../ChatListPrivateTab/PrivateTab";
import GroupTab from "../ChatListGroupTab/GroupTab";
import ChatListControls from "../ChatListControls/ChatListControls";

class ChatList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabIndex: 0,
      prevChat: null,
      chats: [],
      loadingC: true,
      groups: [],
      loadingG: true
    };

    this.handleChange = this.handleChange.bind(this);
    this.openChat = this.openChat.bind(this);
  }

  openChat(chat, type) {
    const firebase = this.context;

    if (this.state.prevChat && this.state.prevChat.type === "private") {
      if (this.state.prevChat.id === chat.id) return;
      const index = this.state.prevChat.activeMembers.findIndex(item => {
        return item === this.props.user.email;
      });
      const status = index === 0 ? "status1" : "status2";
      firebase
        .fs()
        .collection("chats")
        .doc(this.state.prevChat.id)
        .update({
          [status]: "Out"
        });
    }

    if (this.state.prevChat && this.state.prevChat.type === "group") {
      if (this.state.prevChat.id === chat.id) return;
      firebase
        .fs()
        .collection("groups")
        .doc(this.state.prevChat.id)
        .set(
          {
            unread: {
              [this.props.user.uid]: {
                status: "Out"
              }
            }
          },
          { merge: true }
        );
    }

    if (type === "private") {
      const index = chat.activeMembers.findIndex(item => {
        return item === this.props.user.email;
      });

      const status = index === 0 ? "status1" : "status2";
      firebase
        .db()
        .ref("/lastChat/" + this.props.user.uid)
        .set({
          type: "private",
          last_chat: chat.id,
          statusNum: status
        });

      this.setState({ prevChat: { ...chat, type: "private" } });

      if (chat.unread !== this.props.user.email) {
        firebase
          .fs()
          .collection("chats")
          .doc(chat.id)
          .update({
            [status]: "In"
          });
      } else {
        firebase
          .fs()
          .collection("chats")
          .doc(chat.id)
          .update({
            unread: null,
            count: 0,
            [status]: "In"
          });
      }

      this.props.selectChat({ id: chat.id, email: chat.email }, "private");
    } else {
      this.setState({ prevChat: { ...chat, type: "group" } });

      firebase
        .db()
        .ref("/lastChat/" + this.props.user.uid)
        .set({
          type: "group",
          last_chat: chat.id
        });

      firebase
        .fs()
        .collection("groups")
        .doc(chat.id)
        .set(
          {
            unread: {
              [this.props.user.uid]: {
                count: 0,
                status: "In"
              }
            }
          },
          { merge: true }
        );
      this.props.selectChat({ id: chat.id, name: chat.name }, "group");
    }
  }

  handleChange(e, value) {
    this.setState({ tabIndex: value });
  }

  componentDidMount() {
    const firebase = this.context;

    this.chatListener = firebase
      .fs()
      .collection("chats")
      .where("activeMembers", "array-contains", this.props.user.email)
      .onSnapshot(snaps => {
        if (snaps.size === 0) {
          // ! may break the code
          this.setState({ loadingC: false,chats:[] });
          return;
        }
        let chats = [];
        snaps.forEach(snap => {
          let recKey = Object.keys(snap.data().membersInfo).filter(key => {
            return key !== this.props.user.uid;
          });
          let chat = {};
          chat = {
            id: snap.id,
            ...snap.data().membersInfo[recKey],
            activeMembers: snap.data().activeMembers,
            unread: snap.data().unread,
            count: snap.data().count,
            userLastMod:snap.data().membersInfo[this.props.user.uid].lastmod
          };

          chats.push(chat);
        });
        chats.sort((a, b) => {
          if (a.userLastMod < b.userLastMod) return 1;
          if (a.userLastMod > b.userLastMod) return -1;
          return 0;
        });
        this.setState({ chats: [...chats], loadingC: false });
      });

    this.groupListener = firebase
      .fs()
      .collection("groups")
      .where("members", "array-contains", this.props.user.email)
      .orderBy("lastmod", "desc")
      .onSnapshot(snaps => {
        if (snaps.size === 0) {
          // ! may break the code
          this.setState({ loadingC: false,groups:[] });
          return;
        }
        let groups = [];
        if (snaps.empty) {
          this.setState({ loadingG: false });
          return;
        }
        snaps.forEach(snap => {
          if(snap.data().deleted && snap.data().deleted.indexOf(this.props.user.uid) > -1) return;
          groups.push({ id: snap.id, ...snap.data() });
        });
        this.setState({ groups: [...groups], loadingG: false });
      });
  }

  componentDidUpdate(prevProps){
    if(prevProps.chatDeleted === false && this.props.chatDeleted === true){
      this.setState({prevChat:null})
    }
  }

  componentWillUnmount() {
    const firebase = this.context;
    if (this.state.prevChat) {
      if (this.state.prevChat.type === "private") {
        const index = this.state.prevChat.activeMembers.findIndex(item => {
          return item === this.props.user.email;
        });
        const status = index === 0 ? "status1" : "status2";
        firebase
          .fs()
          .collection("chats")
          .doc(this.state.prevChat.id)
          .update({
            [status]: "Out"
          });
      } else {
        firebase
          .fs()
          .collection("groups")
          .doc(this.state.prevChat.id)
          .set(
            {
              unread: {
                [this.props.user.uid]: {
                  status: "Out"
                }
              }
            },
            { merge: true }
          );
      }
    }

    this.chatListener();
    this.groupListener();
  }

  render() {
    const { classes } = this.props;
    const { tabIndex, chats, groups, loadingC, loadingG } = this.state;
    const chatList = (
      <Box  display="flex" flexDirection="column" height="100vh">
        <div className={classes.navMargin} />
        <ChatListControls
          user={this.props.user}
          toggleAlert={this.props.toggleAlert}
          chats={chats}
          groups={groups}
        />

        <Divider />
        <Box>
          <Tabs
            variant="fullWidth"
            value={tabIndex}
            onChange={this.handleChange}
          >
            <Tab label="Private" icon={<Person />} />
            <Tab label="Groups" icon={<Group />} />
          </Tabs>
        </Box>

        <Box mt={1}>
          {!loadingC && (
            <PrivateTab
              user={this.props.user}
              tabIndex={tabIndex}
              openChat={this.openChat}
              chats={chats}
            />
          )}
          {!loadingG && (
            <GroupTab
              user={this.props.user}
              tabIndex={tabIndex}
              openChat={this.openChat}
              groups={groups}
            />
          )}
        </Box>
      </Box>
    );

    return (
      <div>
        <Hidden smUp>
          <Drawer
            variant="temporary"
            open={this.props.chatMobVisible}
            onClose={this.props.toggleChatList}
            classes={{
              paper: classes.drawer
            }}
            ModalProps={{
              keepMounted: true
            }}
          >
            {chatList}
          </Drawer>
        </Hidden>
        <Hidden xsDown>
          <Drawer
            classes={{
              paper: classes.drawer
            }}
            variant="permanent"
            open
          >
            {chatList}
          </Drawer>
        </Hidden>
      </div>
    );
  }
}
ChatList.contextType = FirebaseContext;
export default withStyles(myStyle)(ChatList);
